/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//German (Germany)
export default {
  'editorExtensionLinkCreate.confluencePage.newDraftTitle': 'Seite ohne Titel',
  'editorExtensionLinkCreate.confluencePage.quickInsert.description':
    'Erstellen Sie eine neue Seite und fügen Sie sie als Link ein.',
  'editorExtensionLinkCreate.confluencePage.quickInsert.title': 'Confluence-Seite erstellen',
  'editorExtensionLinkCreate.confluencePage.successFlag.action.open': 'In Confluence öffnen',
  'editorExtensionLinkCreate.confluencePage.successFlag.description': 'Ihre Seite wurde erstellt',
  'editorExtensionLinkCreate.confluencePage.successFlag.title': 'Seite erstellt',
  'editorExtensionLinkCreate.confluencePage.title': 'Neue Seite erstellen',
  'editorExtensionLinkCreate.genericError.description': 'Aktualisieren Sie die Seite und versuchen Sie es dann erneut.',
  'editorExtensionLinkCreate.genericError.title': 'Etwas ist schiefgelaufen',
  'editorExtensionLinkCreate.jiraIssue.quickInsert.description':
    'Erstellen Sie einen Inline-Vorgang und fügen Sie den Vorgang als Link ein.',
  'editorExtensionLinkCreate.jiraIssue.quickInsert.description-issue-terminology-refresh-m4':
    'Erstellen Sie einen Inline-Vorgang und fügen Sie den Vorgang als Link ein.',
  'editorExtensionLinkCreate.jiraIssue.quickInsert.title': 'Jira-Vorgang erstellen',
  'editorExtensionLinkCreate.jiraIssue.quickInsert.title-issue-terminology-refresh-m4': 'Jira-Vorgang erstellen',
  'editorExtensionLinkCreate.jiraIssue.successFlag.action.open': 'In Jira öffnen',
  'editorExtensionLinkCreate.jiraIssue.successFlag.description': 'Ihr Vorgang wurde erstellt',
  'editorExtensionLinkCreate.jiraIssue.successFlag.description-issue-terminology-refresh-m4':
    'Ihr Vorgang wurde erstellt',
  'editorExtensionLinkCreate.jiraIssue.successFlag.title': 'Vorgang erstellt',
  'editorExtensionLinkCreate.jiraIssue.successFlag.title-issue-terminology-refresh-m4': 'Vorgang erstellt',
  'editorExtensionLinkCreate.jiraIssue.title': 'Neuen Vorgang erstellen',
  'editorExtensionLinkCreate.jiraIssue.title-issue-terminology-refresh-m4': 'Neuen Vorgang erstellen',
  'editorExtensionLinkCreate.keyword.create': 'erstellen',
  'editorExtensionLinkCreate.keyword.issue': 'Vorgang',
  'editorExtensionLinkCreate.keyword.new': 'neu',
  'editorExtensionLinkCreate.keyword.page': 'Seite',
  'editorExtensionLinkCreate.keyword.publish': 'veröffentlichen',
  'editorExtensionLinkCreate.keyword.raise': 'erstellen',
  'editorExtensionLinkCreate.keyword.space': 'Bereich',
  'editorExtensionLinkCreate.keyword.ticket': 'Ticket',
};
